export const AUTHORIZATION_MODULE_NAMESPACE = 'authorization';
export const AUTHORIZATION_AUTHORIZE = 'AUTHORIZATION_AUTHORIZE';
export const AUTHORIZATION_SIGNOUT = 'AUTHORIZATION_SIGNOUT';
export const AUTHORIZATION_AUTHORIZE_SUCCESS = 'AUTHORIZATION_AUTHORIZE_SUCCESS';
export const AUTHORIZATION_STATUS = 'AUTHORIZATION_STATUS';
export const AUTHORIZATION_FUNCTIONALITIES = 'AUTHORIZATION_FUNCTIONALITIES';
export const AUTHORIZATION_FORGOT_PASSWORD = 'AUTHORIZATION_FORGOT_PASSWORD';
export const AUTHORIZATION_CHANGE_PASSWORD = 'AUTHORIZATION_CHANGE_PASSWORD';
export const AUTHORIZATION_CHECK_SESSION = 'AUTHORIZATION_CHECK_SESSION';
export const AUTHORIZATION_SIGN_IN = 'AUTHORIZATION_SIGN_IN';
export const AUTHORIZATION_SIGN_IN_FAILED = 'AUTHORIZATION_SIGN_IN_FAILED';
export const AUTHORIZATION_SIGN_IN_LOADING = 'AUTHORIZATION_SIGN_IN_LOADING';
export const AUTHORIZATION_VERIFY_EMAIL = 'AUTHORIZATION_VERIFY_EMAIL';


// WEBPACK FOOTER //
// ./src/store/authorization/authorization-types.store.ts